/**
 * Constantes da aplicação
 */

export const API_ENDPOINTS = {
  // Autenticação
  LOGIN: '/logar/',
  
  // Classificação
  OBTER_CLASSIFICACAO: '/obterClassificacao/',
  
  // Produto
  OBTER_PRODUTO: '/obterProduto/',
  OBTER_PRODUTO_PEDIDO: '/obterProdutoPrevisao/',
  OBTER_PRODUTO_PREVISAO_VENDAS: '/obterProdutoPrevisaoVendas/',
  
  // Cliente
  OBTER_CLIENTE: '/obterCliente/',
  OBTER_CLIENTE_DADOS: '/obterClienteDados/',
  CAD_CLIENTE: '/cadCliente/',
  
  // Carrinho
  CAD_CAR_PREVISAO: '/cadCarPrevisao/',
  CAD_CAR_PEDIDO: '/cadCarPedido/',
  OBTER_PRODUTO_PREVISAO_VENDEDOR: '/obterProdutoPrevisaoVendedor/',
} as const;

export const ROUTES = {
  LOGIN: '/',
  HOME: '/home',
  CLASSIFICACAO: '/classificacao',
  CLASSIFICACAO_PREVISAO: '/classificacoes-previsao',
  CLASSIFICACAO_PEDIDO: '/classificacoes-pedido',
  PRODUTOS: '/produtos/:classificacaoId',
  PRODUTOS_PREVISAO: '/produtos-previsao/:classificacaoId',
  PRODUTOS_PEDIDO: '/produtos-pedido/:classificacaoId',
  ITENS_PREVISAO: '/itens-previsao',
  CLIENTES: '/clientes',
  CLIENTE_DETALHE: '/cliente/:clienteId',
  CAD_CLIENTE: '/cadastrar-cliente',
  CARRINHO: '/carrinho',
  CARRINHO_PREVISAO: '/carrinho-previsao',
  CARRINHO_PEDIDO: '/carrinho-pedido',
} as const; 

export const SESSION_KEYS = {
  VEND_CODIGO: 'vendCodigo',
  VEND_TIPO: 'vendTipo',
  VEND_NOME: 'vendNome',
  VEND_EMAIL: 'vendEmail',
  IND_PEDIDO: 'indPedido',
  IND_PREVISAO: 'indPrevisao',
  IND_PREVISAO_ID: 'indPrevisaoId',
  IND_PREVISAO_INI: 'indPrevisaoIni',
  IND_PREVISAO_FIM: 'indPrevisaoFim',
  IND_PREVISAO_CONFIRMA: 'indPrevisaoConfirma',
  CLI_CODIGO: 'cliCodigo',
  CLI_NOME: 'cliNome',
  CARRINHO: 'carrinho',
  CARRINHO_TIPO: 'carrinhoTipo',
  LAST_CLASSIFICACAO: 'lastClassificacao',
  LAST_PRODUTO: 'lastProduto',
} as const;

export const MENSAGENS = {
  ERRO_GENERICO: 'Ocorreu um erro. Tente novamente.',
  ERRO_CONEXAO: 'Erro de conexão. Verifique sua internet.',
  ERRO_AUTENTICACAO: 'Usuário ou senha inválidos.',
  SUCESSO_LOGIN: 'Login realizado com sucesso!',
  SUCESSO_CADASTRO: 'Cadastro realizado com sucesso!',
  SUCESSO_PEDIDO: 'Pedido enviado com sucesso!',
  SUCESSO_PREVISAO: 'Previsão enviada com sucesso!',
  CLIENTE_ATIVO: 'Cliente ativo',
  CLIENTE_SEM_CREDITO: 'Cliente possui débitos em aberto.',
  CLIENTE_BLOQUEADO: 'Cliente possui débitos em aberto e não pode realizar pedidos',
  PRECO_MINIMO: 'O preço não pode ser menor que o valor mínimo.',
  ESTOQUE_INSUFICIENTE: 'Estoque insuficiente.',
  CARRINHO_VAZIO: 'Adicione produtos ao carrinho.',
  SELECIONE_CLIENTE: 'Selecione um cliente para continuar.',
} as const;

export const FOOTER_BUTTONS = {
  HOME: {
    label: 'Início',
    icon: 'home',
  },
  CLIENTES: {
    label: 'Clientes',
    icon: 'people',
  },
  PRODUTOS: {
    label: 'Produtos',
    icon: 'inventory',
  },
  PREVISAO: {
    label: 'Previsão',
    icon: 'analytics',
  },
  PEDIDO: {
    label: 'Pedido',
    icon: 'shopping_cart',
  },
  CADASTRO: {
    label: 'Cadastrar',
    icon: 'person_add',
  },
} as const;

export const TIPOS_VENDEDOR = {
  ADMINISTRADOR: '1',
  VENDEDOR: '2',
  SUPERVISOR: '3',
} as const;

export const STATUS_FINANCEIRO = {
  ATIVO: 0,
  INATIVO: 1,
} as const;